import { useState } from 'react';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-blue-light/95 backdrop-blur-md shadow-lg z-50 border-b border-blue-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2 sm:space-x-3 animate-slide-right">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">
            <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
            </svg>
          </div>
          <h1 className="text-lg sm:text-2xl font-bold text-gray-900">Tej</h1>
        </div>
        
        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-8 text-gray-800">
          <li><a href="#home" className="hover:text-blue-600 transition-colors duration-300 font-medium">Home</a></li>
          <li><a href="#about" className="hover:text-blue-600 transition-colors duration-300 font-medium">About</a></li>
          <li><a href="#projects" className="hover:text-blue-600 transition-colors duration-300 font-medium">Projects</a></li>
          <li><a href="#skills" className="hover:text-blue-600 transition-colors duration-300 font-medium">Skills</a></li>
          <li><a href="#contact" className="hover:text-blue-600 transition-colors duration-300 font-medium">Contact</a></li>
        </ul>
        
        {/* Hamburger Menu */}
        <button 
          className="md:hidden flex flex-col space-y-1 p-2" 
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className={`w-6 h-0.5 bg-gray-800 transition-all ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-gray-800 transition-all ${isOpen ? 'opacity-0' : ''}`}></span>
          <span className={`w-6 h-0.5 bg-gray-800 transition-all ${isOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
      </div>
      
      {/* Mobile Menu */}
      <div className={`md:hidden bg-blue-light/95 backdrop-blur-md border-t border-blue-300 transition-all duration-300 ${isOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <ul className="px-4 py-4 space-y-4">
          <li><a href="#home" className="block text-gray-800 hover:text-blue-600 transition-colors font-medium" onClick={() => setIsOpen(false)}>Home</a></li>
          <li><a href="#about" className="block text-gray-800 hover:text-blue-600 transition-colors font-medium" onClick={() => setIsOpen(false)}>About</a></li>
          <li><a href="#projects" className="block text-gray-800 hover:text-blue-600 transition-colors font-medium" onClick={() => setIsOpen(false)}>Projects</a></li>
          <li><a href="#skills" className="block text-gray-800 hover:text-blue-600 transition-colors font-medium" onClick={() => setIsOpen(false)}>Skills</a></li>
          <li><a href="#contact" className="block text-gray-800 hover:text-blue-600 transition-colors font-medium" onClick={() => setIsOpen(false)}>Contact</a></li>
        </ul>
      </div>
    </nav>
  );
}
